import { PageHeader } from '../components/ui/PageHeader.tsx';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.ts';
import { BrandingBox } from './platform/TenantsPages.tsx';

/** 설정 › 브랜딩 (tenant_admin): 로고·강조색·표시명. 로그인 화면·GNB·메일 머리말에 적용 */
export function BrandingSettingsPage() {
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ['tenant-branding'], queryFn: () => api<{ tenantName: string; displayName: string | null; accent: string | null; header: string | null; logoUrl: string | null }>('/tenant/branding') });
  return (
    <div>
      <PageHeader title="브랜딩" description="로고(PNG·SVG, 512KB 이하)·강조색·헤더 색·표시명은 로그인 화면과 상단 메뉴바에 적용됩니다. 비우면 PRISM 기본 브랜드를 씁니다." />
      {q.data && <BrandingBox branding={q.data} onSaved={() => { qc.invalidateQueries({ queryKey: ['tenant-branding'] }); qc.invalidateQueries({ queryKey: ['branding'] }); }} />}
    </div>
  );
}
